import { FunctionComponent } from "react";
import { faTrash, faBan, faLock, faArrowRight } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";
import { Toggle } from "@/components/Toggle/Toggle";
import { Tooltip } from "@/components/Tooltip/Tooltip";

import { TargetFieldBadges, TargetFieldBadgesData } from "./TargetFieldBadges";

interface CannotMapRowProps {
	targetFieldLabel: string;
	targetField: TargetFieldBadgesData;
	cannotMapLabel: string;
	tooltip: string;
	badgeLabels: {
		required: string;
		multi: string;
		dropdown: string;
		number: string;
		calculated: string;
		readOnly: string;
	};
	onDelete?: () => void;
	testIdPrefix: string;
}

export const CannotMapRow: FunctionComponent<CannotMapRowProps> = ({
	targetFieldLabel,
	targetField,
	cannotMapLabel,
	tooltip,
	badgeLabels,
	onDelete,
	testIdPrefix,
}) => {
	return (
		<div
			className="flex items-center gap-3 py-3 border-b border-gray-100"
			data-testid={`${testIdPrefix}-cannot-map-row`}
		>
			<div className="flex-1">
				<div className="flex items-center gap-2 py-[9px] px-3 rounded-xl border border-border-light bg-brand-white text-ssm text-text-disabled">
					<Icon className="w-4 h-4 text-text-disabled" icon={faBan} />
					<span className="italic">{cannotMapLabel}</span>
				</div>
			</div>
			<div className="w-[24px] flex items-center justify-center">
				<Icon className="w-[16px] h-[16px] text-gray-400" icon={faArrowRight} />
			</div>
			<div className="flex-1">
				<Tooltip content={tooltip}>
					<div className="flex items-center gap-2 py-[9px] px-3 rounded-xl border border-border-light bg-brand-white text-ssm text-text">
						<Icon className="w-4 h-4 text-text-meta" icon={faLock} />
						<span className="flex-1 truncate">{targetFieldLabel}</span>
						<TargetFieldBadges
							field={targetField}
							labels={badgeLabels}
							testIdPrefix={testIdPrefix}
						/>
					</div>
				</Tooltip>
			</div>
			<div className="w-[60px] flex items-center justify-center">
				<Toggle isChecked={false} onChange={() => {}} />
			</div>
			{onDelete ? (
				<div
					className="w-fit bg-status-error-light flex justify-end p-1 rounded border-border-light cursor-pointer"
					onClick={onDelete}
				>
					<Icon className="text-status-error w-4 h-4" icon={faTrash} />
				</div>
			) : (
				<div className="w-fit p-1" />
			)}
		</div>
	);
};
